"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.match");

require("core-js/modules/es.string.replace");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cookie2 = _interopRequireDefault(require("@zz-common/zz-utils/lib/cookie"));

var _day2 = _interopRequireDefault(require("@zz-common/zz-utils/lib/day"));

var _client = _interopRequireDefault(require("./client"));

var date = (0, _day2.default)().format('YYYY-MM-DD');

var _default = function _default(fn) {
  var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    var config = Object.assign({}, {
      environment: process.env.NODE_ENV || 'production',
      ignoreErrors: [/HTMLHeadElement.appendChild/, /Java object/, /responseText/, /WeixinJSBridge is not defined/gi, 'top.GLOBALS', 'originalCreateNotification', 'canvas.contentDocument', /webpack/gi, /^Error: Network Error$/g, 'Error: Timeout', /window.zhuanzhuanMApplication.executeCmd/, /window.zhuanzhuanM/, /zzcallback_/, /InvalidStateError: Failed to read/, /Loading chunk /, /ResizeObserver loop/, /zzcallbackV2_/, /zzcallback/],
      blacklistUrls: [/extensions\//i, /^chrome:\/\//i, /webappstoolbarba\.texthelp\.com\//i, /metrics\.itunes\.apple\.com\.edgesuite\.net\//i],
      beforeSend: function beforeSend(event, hint) {
        if (event.environment !== 'production' && !cfg.senddev) return;
        var error = hint.originalException;
        var userId = _cookie2.default.get('uid') || _cookie2.default.get('sso_uid') || 'nofound';
        var t = _cookie2.default.get('zz_t') || _cookie2.default.get('t') || '';
        var ua = navigator.userAgent.match(/zzVersion\/(.*?)\s/) ? navigator.userAgent.match(/zzVersion\/(.*?)\s/)[1] : '';
        var version = _cookie2.default.get('v') || ua;
        event.tags = event.tags ? event.tags : {
          t: t,
          version: version,
          tVersion: "".concat(t, " ").concat(version),
          client: (0, _client.default)(),
          route: location.hash && location.hash.replace(/(#)([^\?]*)(\?.*)*/g, '$2') || '',
          env: process.env.NODE_ENV || '未知',
          date: date,
          tel: _cookie2.default.get('tel') || '',
          uid: userId,
          errorType: '被动上报错误',
          errInfo: error && error.message,
          isSendEmail: 2
        };
        event.extra = event.extra ? event.extra : {
          cookie: _cookie2.default.get(),
          UA: navigator.userAgent
        };

        if (error && error.message && !event.fingerprint) {
          event.fingerprint = [process.env.NODE_ENV, '被动上报错误', error && error.message];
        }

        event.message = error && error.message;
        return event;
      }
    }, cfg);

    if (fn) {
      fn(config);
    }
  } catch (err) {
    console.warn(err);
  }
};

exports.default = _default;